module.exports = __webpack_public_path__ + "img/btn_google_dark_focus_ios.3c5af3a2.svg";